import { JSONContent } from '@tiptap/core'
import { stateToJson } from './plain-text-to-ydoc'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmpty = (value: string | Record<string, any>) => {
  if (!value) return true
  const json = typeof value === 'string' ? stateToJson(value) : value
  return isEmptyJson(json as Record<string, any>)
}

//
export const isEmptyJson = (json: JSONContent) => {
  let _isEmpty = false
  if (!json?.type) {
    _isEmpty = true
  } else if (json.type === 'doc') {
    if (!json.content || json.content.length === 0) {
      _isEmpty = true
    } else if (json.content.length === 1) {
      const firstNode = json.content[0]!
      if (firstNode.type === 'paragraph') {
        if (!firstNode.content || firstNode.content.length === 0) {
          _isEmpty = true
        } else if (firstNode.content.length) {
          const firstNodeContent = firstNode.content[0]!
          if (
            firstNodeContent.type === 'text' &&
            firstNodeContent.text?.trim() === ''
          ) {
            _isEmpty = true
          }
        }
      }
    }
  }

  return _isEmpty
}

type IsReallyEmptyJsonOptions = {
  debug?: boolean
}

const defaultOptions: IsReallyEmptyJsonOptions = {
  debug: false,
}

export const isReallyEmptyJson = (
  input: JSONContent | { doc: JSONContent },
  options?: IsReallyEmptyJsonOptions
) => {
  options = { ...defaultOptions, ...options }
  const json: JSONContent = 'doc' in input ? input.doc : input
  if (options?.debug) {
    console.log('isReallyEmptyJson', json)
  }

  if (!json.type || json.type !== 'doc') return true
  if (!json.content) return false

  return !json.content.some((node) => {
    if (!node || node.type !== 'paragraph') return true
    if (!node.content?.length) return false

    return node.content.some(
      (n) => n.type === 'text' && n.text && n.text.trim() !== ''
    )
  })
}
